import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PromotionItems } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/PromotionItems/index.js';
import { TopDestinations } from '../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/TopDestinations/index.js';
export const BlockLinks = ({
  item,
  onSelectKeyword
}) => {
  if (item.type === 'text_and_icon') {
    return _jsx(PromotionItems, {
      item: item,
      onSelectKeyword: onSelectKeyword
    });
  }
  if (item.type === 'image') {
    return _jsx(TopDestinations, {
      item: item,
      onSelectKeyword: onSelectKeyword
    });
  }
  return null;
};